import * as React from "react";
import {
  Avatar,
  Backdrop,
  CircularProgress,
  Grid,
  Link,
  Typography,
} from "@mui/material";

import DataGridComponent from "../../components/DataGridComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutline, ModeEditOutlineOutlined } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { toast } from "react-toastify";
import { deleteProduct, listProducts } from "../../actions/productActions";
import { PRODUCT_DELETE_RESET } from "../../constants/productContansts";

export default function CategoryList() {
  const { palette } = useTheme();
  const columns = [
    {
      field: "name",
      width: 200,
      headerName: "Name",
      renderCell: (params) => {
        return <> {params.row.name} </>;
      },
    },
    {
      field: "sku",
      width: 200,
      headerName: "SKU Number",
      renderCell: (params) => {
        return <> {params.row.sku} </>;
      },
    },
    {
      field: "image",
      headerName: "Image",
      width: 150,
      renderCell: (params) => {
        return <Avatar src={params.row.image} />;
      },
    },
    {
      field: "price",
      width: 200,
      headerName: "Price",
      renderCell: (params) => {
        return <> {params.row.price} </>;
      },
    },
    {
      field: "qty",
      width: 200,
      headerName: "Quantity",
      renderCell: (params) => {
        return <> {params.row.qty} </>;
      },
    },
    {
      field: "description",
      width: 200,
      headerName: "Description",
      renderCell: (params) => {
        return <> {params.row.description} </>;
      },
    },
    {
      field: "description",
      width: 200,
      headerName: "Description",
      renderCell: (params) => {
        return <> {params.row.description} </>;
      },
    },
    {
      field: "store",
      width: 200,
      headerName: "Store",
      renderCell: (params) => {
        return <> {params.row.store && params.row.store.name} </>;
      },
    },
    {
      field: "brand",
      width: 200,
      headerName: "Brand",
      renderCell: (params) => {
        return <> {params.row.brand && params.row.brand.name} </>;
      },
    },
    {
      field: "category",
      width: 200,
      headerName: "Category",
      renderCell: (params) => {
        return <> {params.row.category && params.row.category.name} </>;
      },
    },
    {
      field: "color",
      width: 200,
      headerName: "Color",
      renderCell: (params) => {
        return <> {params.row.attributes.map((item) =>item.color && item.color.name  )} </>;
      },
    },
    {
      field: "size",
      width: 200,
      headerName: "Size",
      renderCell: (params) => {
        return <> {params.row.attributes.map((item) => item.size && item.size.name)} </>;
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            <Link href={`/product/${params.row._id}`}>
              <ModeEditOutlineOutlined
                style={{
                  color: palette.primary.main,
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              />
            </Link>
            <DeleteOutline
              className="delIcon"
              sx={{
                cursor: "pointer",
                color: palette.error.main,
              }}
              onClick={() => handleDelete(params.row._id)}
            />
          </>
        );
      },
    },
  ];

  const dispatch = useDispatch();

  const productList = useSelector((state) => state.productList);
  const { loading, error, products } = productList;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productDelete = useSelector((state) => state.productDelete);
  const { success } = productDelete;

  React.useEffect(() => {
    dispatch(listProducts());
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (success) {
      toast("Product deleted successfully");
      dispatch({ type: PRODUCT_DELETE_RESET });
    }
  }, [dispatch, userInfo, success]);

  const navigate = useNavigate();

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete the Product?")) {
      dispatch(deleteProduct(id));
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        {error && (
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        )}

        {products && (
          <DataGridComponent
            buttonTitle={"Add Product"}
            onClick={() => navigate("/addProduct")}
            title={"Product List"}
            columns={columns}
            rows={products}
          />
        )}
      </Grid>
    </Grid>
  );
}
